import { h } from '@stencil/core';

const GoBackIcon = () => {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12.675H18M18 12.675L12.9701 7.67499M18 12.675L12.9701 17.675" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20 17.675V7.67499" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default GoBackIcon;